import type { GroupStyleT, StyleInputT } from "tweenly"
import { MAX_INPUT_NUM } from "../../../constants"

const positiveUnitaryInput: StyleInputT = {
    type: "number",
    props: {
        inputProps: {
            min: 0,
            max: MAX_INPUT_NUM,
            step: 1,
        },
    },
}

export const blur: GroupStyleT = {
    property: "blur",
    value: 0,
    unit: "px",
    type: "filter",
    input: {
        ...positiveUnitaryInput,
        label: "blur",
    },
    render: (value, unit) => ({ property: "filter", value: `blur(${value + unit})` }),
}

export const backgroundBlur: GroupStyleT = {
    property: "backgroundBlur",
    value: 0,
    unit: "px",
    type: "filter",
    input: {
        ...positiveUnitaryInput,
        label: "background blur",
    },
    render: (value, unit) => ({ property: "backdropFilter", value: `blur(${value + unit})` }),
}

export const dropShadow: GroupStyleT = {
    property: "dropShadow",
    value: {
        offsetX: 0,
        offsetY: 4,
        blur: 4,
        spread: 0,
        color: { r: 0, g: 0, b: 0, a: 0.25 },
    },
    type: "filter",
    input: {
        type: "shadow",
        props: "",
        label: "drop shadow",
    },
    render: (value, unit = undefined, type) => {
        // Handle both old string format (backward compatibility) and new object format
        if (typeof value === "string") {
            return type === "css"
                ? { property: "filter", value: `drop-shadow(${value})` }
                : { property: "filter", value: `drop-shadow(${value})` }
        }

        // New structured format
        const { offsetX, offsetY, blur, color } = value
        // Note: spread is ignored because CSS drop-shadow doesn't support it (only box-shadow does)
        const shadowStr = `${offsetX}px ${offsetY}px ${blur}px rgba(${color.r}, ${color.g}, ${color.b}, ${color.a})`

        // Using drop-shadow for now (works with filters)
        return type === "css"
            ? { property: "filter", value: `drop-shadow(${shadowStr})` }
            : { property: "filter", value: `drop-shadow(${shadowStr})` }
    },
}

// all possible filters for custom fields
export const filters = [blur, backgroundBlur, dropShadow]
export const filterNames = ["blur", "backgroundBlur", "dropShadow"]
